// extracted by mini-css-extract-plugin
export var arrows = "_2q-5";
export var decrementer = "_2q-9";
export var disabled = "_2q-3";
export var error = "_2q-1";
export var hiddenText = "_2q-a";
export var incrementer = "_2q-8";
export var input = "_2q-7";
export var inputWrapper = "_2q-0";
export var leadingIcon = "_2q-b";
export var readonly = "_2q-2";
export var regular = "_2q-6";
export var small = "_2q-4";